import { Link } from "react-router-dom";
import "./LandingTopbar.css";
import Button from "../ui/Button";
import { useAuth } from "../../context/AuthContext";

const NAV_ITEMS = [
  { label: "Home", to: "/" },
  { label: "Over ons", href: "#over-ons" },
  { label: "Toepassing", href: "#toepassing" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", to: "/contact" },
];

function LandingTopbar() {
  const { isAuthenticated } = useAuth();
  const loginTarget = isAuthenticated ? "/blog" : "/login";
  return (
    <header className="landing-topbar">
      <div className="landing-topbar__inner">
        <div className="landing-topbar__left">
          <Link to="/" className="landing-topbar__brand">
            <img src="/logo-wit.png" alt="Kurtosis" className="landing-topbar__logo" />
          </Link>

          <nav className="landing-topbar__nav" aria-label="Landingspagina navigatie">
            {NAV_ITEMS.map((item) =>
              item.to ? (
                <Link key={item.label} to={item.to} className="landing-topbar__nav-item">
                  {item.label}
                </Link>
              ) : (
                <a key={item.label} className="landing-topbar__nav-item" href={item.href}>
                  {item.label}
                </a>
              )
            )}
          </nav>
        </div>

        <Link to={loginTarget} className="landing-topbar__cta">
          <Button variant="primary">Log in</Button>
        </Link>
      </div>
    </header>
  );
}

export default LandingTopbar;
